const actions = {

    STORE_DASHBOARD_DATA_BEGIN : 'STORE_DASHBOARD_DATA_BEGIN',
    STORE_DASHBOARD_DATA_SUCCESS: 'STORE_DASHBOARD_DATA_SUCCESS',
    STORE_DASHBOARD_DATA_ERR : 'STORE_DASHBOARD_DATA_ERR',

    storeDashboardDataBegin: () => {
        return {
            type: actions.STORE_DASHBOARD_DATA_BEGIN,
        };
    },

    storeDashboardDataSuccess: (data) => {
        return {
            type: actions.STORE_DASHBOARD_DATA_SUCCESS,
            data,
        };
    },

    storeDashboardDataErr: (err) => {
        return {
            type: actions.STORE_DASHBOARD_DATA_ERR,
            err,
        };
    },
};

export default actions;
